import { useEffect, useState } from "react";

const parse = (text) =>
  text
    .split(",")
    .map((v) => v.trim())
    .filter(Boolean);

// A comma-separated email field backed by a list. The typed text is kept as
// is: rebuilding it from the parsed list on every keystroke threw away a
// trailing comma, so a second address could never be started.
export default function EmailListInput({ value, onChange, ...inputProps }) {
  const list = value || [];
  const [text, setText] = useState(list.join(", "));

  // Follow the list when it changes from outside (another class loaded),
  // but not when it is just the parse of what is being typed.
  useEffect(() => {
    if (parse(text).join(",") !== list.join(",")) setText(list.join(", "));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.join(",")]);

  return (
    <input
      {...inputProps}
      type="text"
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        onChange(parse(e.target.value));
      }}
    />
  );
}
